<mat-icon matTooltip="{{ params.value }}" matTooltipPosition="after" class="material-icons {{ iconClass }}">{{ iconName }}</mat-icon>
